<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  watch: {
    $route() {
      document.title = this.$route.meta.title;
      document.getElementById("app").scroll(0, 0);
    },
  },
};
</script>
